import * as React from "react";
import SearchIcon from "material-ui/svg-icons/action/search";
import * as algoliasearch from 'algoliasearch'

import './DocSearch.scss';

const searchClient = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_ADMIN_KEY);
const docsIndex = searchClient.initIndex('Docs');

function pageToAlgoliaRecord({ node: { id, frontmatter, htmlAst, ...rest } }) {
	const h2Childrens = htmlAst.children.filter(ch => ch.tagName === "h2")
	const sections = h2Childrens.map(ch => ch.properties.id)
	return {
	  objectID: id,
	  sections: sections,
	  ...frontmatter,
	  ...rest,
	}
}

interface DocSearchProps {
	style?: any;
	onFocus(): void;
	onBlur(): void;
	isInFocus: boolean;
	data?: {
		pages: {
			edges: Array<{
				node: {
					id: string;
					frontmatter: {
						title: string;
						path: string;
						category: string;
						platform: string;
						group: string;
					};
					htmlAst: any;
				};
			}>;
		};
	};
}

class DocSearch extends React.Component<DocSearchProps, any> {
	state = {
		value: "",
		clicked: false,
		hitsApi: [],
		hitsDocs: [],
		closeSearch: false
	};

	onChange(value) {
		this.setState({value: value})
		if (value.length > 2) {
			this.setState({closeSearch: false})
			docsIndex.search(value).then(({ hits }) => {
				this.setState({hitsApi: hits.filter(h => h.category === "api")})
				this.setState({hitsDocs: hits.filter(h => h.category === "documentation")})
			});
		}
	}

	onFocus(data) {
		if (!this.state.clicked) {
			const docsAlgolia = data.pages.edges.map(pageToAlgoliaRecord)
			docsIndex.clearIndex()
			docsIndex.saveObjects(docsAlgolia, {autoGenerateObjectIDIfNotExist: true})
			this.setState({clicked: true});
		}
		if (this.state.closeSearch) {
			this.setState({closeSearch: false})
		}
		this.props.onFocus()
	}

	// onBlur() {
	// 	this.setState({value: ""});
	// 	this.search&&this.search.autocomplete.autocomplete.setVal("");
	// 	this.input.blur();
	// }

	onClose() {
		this.setState({value: ""})
	}

	searchHitsElements(hits) {
		return hits.map(h => {
			return (
			<li className="docs" key={h.objectID}>
				<a href={'/'+h.category+'/'+h.platform+h.path} className="flex-container align-items-center" onClick={() => this.setState({closeSearch: true})}>
					<div className="data-holder">
						<p>{h.title}</p>
						<span>{`${h.category} > ${h.platform} > ${h.group}`}</span>
					</div>
				</a>
			</li>)
		})
	}

	render() {
		const valueLength = this.state.value.length;
		const hitsApiLength = this.state.hitsApi.length
		const hitsDocsLength = this.state.hitsDocs.length
		const closeButton = require('../res/close_button_icon.svg');

		return (
			<div style={this.props.style} className="general-search">
				<span className="search-back" onClick={() => document.querySelector('.general-search').style.display = "none"}><i className="far fa-chevron-left" /></span>
				<SearchIcon style={{width: 25,height: 25,cursor: "pointer",}} />
				<input 
					type="text" 
					placeholder="Search..." 
					id="search-box" 
					onClick={() => this.onFocus(this.props.data)}
					onChange={(e) => {
						this.onChange(e.target.value);
					}}
					value={this.state.value}
				/>
				{valueLength > 0 ? <span className="close-button" onClick={() => this.onClose()}><img src={closeButton}/></span> : null}

				{valueLength > 2 && !this.state.closeSearch && this.props.isInFocus ? 
				<div className="initial-search-results search-container">
					<ul>
						{hitsApiLength > 0 ? (<li className="docs results-header hide">API Reference</li>) : null}
						{this.searchHitsElements(this.state.hitsApi)}
						{hitsDocsLength > 0 ? (<li className="docs results-header hide">Documentation</li>) : null}
						{this.searchHitsElements(this.state.hitsDocs)}
						{hitsApiLength === 0 && hitsDocsLength === 0 ? (<li className="no-results results-header">No results found</li>) : null}
					</ul>
				</div> : null
			}

			</div>
		);
	}
}

export default DocSearch;





// WEBPACK FOOTER //
// ./src/components/DocSearch.tsx